import { subscribeKey } from 'valtio/utils'
import type { GraphicsBackendLoader } from './appViewer'
import { options } from './optionsStorage'
import { appViewer } from './appViewer'
import { miscUiState } from './globalState'
import { watchOptionsAfterViewerInit } from './watchOptions'

export const appGraphicBackends: GraphicsBackendLoader[] = []

export const getAppGraphicBackends = async () => {
  if (!appGraphicBackends.length) {
    const { default: createGraphicsBackend } = await import('renderer/viewer/three/graphicsBackend')
    appGraphicBackends.push(createGraphicsBackend)
  }
  return appGraphicBackends
}

const loadBackend = async () => {
  const backends = await getAppGraphicBackends()
  let backend = backends.find(backend => backend.id === options.activeRenderer)
  if (!backend) {
    backend = backends[0]
    console.warn(`No backend found for renderer ${options.activeRenderer}. Falling back to ${backend.id}.`)
    options.activeRenderer = backend.id
  }
  await appViewer.loadBackend(backend)
}
window.loadBackend = loadBackend

export const appLoadBackend = async () => {
  if (process.env.SINGLE_FILE_BUILD_MODE) {
    const unsub = subscribeKey(miscUiState, 'fsReady', () => {
      if (miscUiState.fsReady) {
        // don't do it earlier to load fs and display menu faster
        void loadBackend()
        unsub()
      }
    })
  } else {
    setTimeout(() => {
      void loadBackend()
    })
  }

  watchOptionsAfterViewerInit()

  // reset backend when renderer changes
  subscribeKey(options, 'activeRenderer', async () => {
    if (appViewer.currentDisplay === 'world' && bot) {
      appViewer.resetBackend(true)
      await loadBackend()
      void appViewer.startWithBot()
    }
  })
}

const animLoop = () => {
  for (const fn of beforeRenderFrame) fn()
  requestAnimationFrame(animLoop)
}
requestAnimationFrame(animLoop)
